<script lang="ts">
  import { imgSrc } from '#app/lib/image_source'
  import { hasTruthy, loadInternalLink } from '#app/lib/utils'
  import { formatYearClaim } from '#entities/components/lib/claims_helpers'
  import type { SerializedEntity } from '#entities/lib/entities'
  import { getBestLangValue } from '#entities/lib/get_best_lang_value'
  import { getCurrentLang, i18n } from '#user/lib/i18n'

  const {
    entity,
    claimValue,
    hasManyClaimValues,
  }: {
    entity: SerializedEntity
    claimValue: string
    hasManyClaimValues: boolean
  } = $props()

  const uri = $derived(entity.uri)
  const labels = $derived(entity.labels)
  const claims = $derived(entity.claims)
  const image = $derived(entity.image)

  const label = $derived.by(() => {
    if (uri) {
      const bestValue = getBestLangValue(getCurrentLang(), null, labels)
      if (hasTruthy(bestValue, 'value')) return bestValue.value
    } else {
      return claimValue
    }
  })

  const url = $derived(uri ? `/entity/${uri}` : `/search?q=!a ${label}`)

  const birthOrDeathDates = $derived(claims['wdt:P569']?.[0] || claims['wdt:P570']?.[0])
</script>

<a
  href={url}
  title={label}
  onclick={loadInternalLink}
  class:hasManyClaimValues
>
  {#if image?.url}
    <img src={imgSrc(image.url, 56)} alt="" loading="lazy" />
  {/if}
  <div class="author-info">
    <p class="author-label">{label}</p>
    {#if birthOrDeathDates}
      <span title={i18n('wdt:P569')}>
        {formatYearClaim('wdt:P569', claims)}
      </span>
      -
      <span title={i18n('wdt:P570')}>
        {formatYearClaim('wdt:P570', claims)}
      </span>
    {/if}
  </div>
</a>

<style lang="scss">
  @import "general/scss/utils";
  a{
    @include display-flex(row, center, flex-start);
    background-color: $off-white;
    block-size: 4em;
    min-inline-size: 12em;
    margin-inline-end: 0.5em;
    margin-block-end: 0.5em;
    &:hover{
      opacity: 0.8;
      cursor: pointer;
    }
    img{
      height: 100%;
      width: 4rem;
      object-fit: cover;
    }
  }
  .hasManyClaimValues{
    inline-size: 15em;
  }
  .author-info{
    flex: 1;
    text-align: center;
  }
  .author-label{
    font-weight: bold;
    margin-inline: 0.5em;
    max-inline-size: 15em;
  }
</style>
